/*
 * Entro Cart Drawer (Oct 2026)
 * Full-height side drawer replacing the theme's small mini-cart dropdown:
 * search items in cart, +/- quantity, remove with undo, clear cart with a two-step confirm,
 * promo codes, order notes (saved to the order note = "Notes Customer Added" on Order Printer packing slips),
 * subtotal with discounts, free-shipping progress, line-cap meter, View cart / Checkout.
 * Opens from the header cart icon and after the theme's own Add to cart.
 */
(function () {
  if (window.EntroCart) return;

  var CFG = Object.assign({ freeShipping: 0, lineCap: 150 }, window.EntroCartConfig || {});
  var nfetch = (window.EntroBulk && window.EntroBulk.nativeFetch) || window.fetch.bind(window);
  var cart = null, drawer = null, lastFocus = null, pending = {}, undoItem = null, undoTimer = null, noteTimer = null;

  function money(c) { return '$' + ((Number(c) || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function cap() { return (window.EntroBulk && window.EntroBulk.config.lineCap) || CFG.lineCap; }
  function api(url, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Entro-Bulk': '1' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return nfetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function syncTheme(c) {
    document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }
  function codesOf(c) { return ((c && c.discount_codes) || []).map(function (d) { return d.code; }); }

  /* ---------- build drawer ---------- */
  function build() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'ec';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="ec__overlay" data-ec-close></div>' +
      '<aside class="ec__panel" role="dialog" aria-modal="true" aria-labelledby="ec-title" tabindex="-1">' +
        '<header class="ec__head">' +
          '<div><h2 id="ec-title" class="ec__title">My Cart</h2><p class="ec__sub"></p></div>' +
          '<button type="button" class="ec__x" data-ec-close aria-label="Close cart">&times;</button>' +
        '</header>' +
        '<div class="ec__tools">' +
          '<div class="ec__search"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '<input type="search" class="ec__q" placeholder="Search items in cart (name, SKU, model)" aria-label="Search items in cart"></div>' +
          '<div class="ec__meta"><span class="ec__cap"></span><button type="button" class="ec__clear">Clear cart</button></div>' +
          '<div class="ec__ship" hidden><div class="ec__ship-text"></div><div class="ec__ship-bar"><span></span></div></div>' +
        '</div>' +
        '<div class="ec__body"><ul class="ec__list" role="list"></ul><p class="ec__nomatch" hidden>No items in your cart match that search.</p>' +
          '<div class="ec__empty" hidden><p>Your cart is empty.</p><a class="button button--primary" href="/collections/all">Start shopping</a></div></div>' +
        '<div class="ec__toast" role="status" aria-live="polite" hidden></div>' +
        '<footer class="ec__foot">' +
          '<details class="ec__box ec__box--promo">' +
            '<summary><span>Promo code</span><span class="ec__box-state"></span></summary>' +
            '<div class="ec__promo"><input type="text" class="ec__promo-input" placeholder="Enter promo code" aria-label="Promo code" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
            '<button type="button" class="button button--secondary ec__promo-apply">Apply</button></div>' +
            '<div class="ec__codes"></div><p class="ec__promo-msg" role="status" aria-live="polite"></p>' +
          '</details>' +
          '<details class="ec__box ec__box--note">' +
            '<summary><span>Order notes &amp; special requests</span><span class="ec__box-state"></span></summary>' +
            '<label class="visually-hidden" for="ec-note">Order notes and special requests</label>' +
            '<textarea id="ec-note" class="ec__note" rows="3" maxlength="1000" placeholder="PO number, delivery instructions, packing requests or anything our team should know"></textarea>' +
            '<p class="ec__note-hint"><span>Sent to our team with your order and printed on your packing slip.</span><span class="ec__note-status" aria-live="polite"></span></p>' +
          '</details>' +
          '<div class="ec__lines"><div class="ec__line-row ec__orig" hidden><span>Items</span><span class="ec__orig-val"></span></div>' +
          '<div class="ec__line-row ec__disc" hidden><span>Discount</span><span class="ec__disc-val"></span></div></div>' +
          '<div class="ec__subtotal"><span>Subtotal</span><strong class="ec__total">$0.00</strong></div>' +
          '<p class="ec__note-small">Shipping and taxes are calculated at checkout.</p>' +
          '<div class="ec__btns"><a class="button button--secondary ec__view" href="/cart">View cart</a><a class="button button--primary ec__checkout" href="/checkout">Checkout</a></div>' +
        '</footer>' +
        '<div class="ec__confirm" role="alertdialog" aria-modal="true" aria-labelledby="ec-confirm-title" hidden>' +
          '<div class="ec__confirm-box">' +
            '<p id="ec-confirm-title" class="ec__confirm-title">Empty your entire cart?</p>' +
            '<p class="ec__confirm-text"></p>' +
            '<label class="ec__confirm-check"><input type="checkbox" class="ec__confirm-ok"> I understand this removes every item and can\'t be undone.</label>' +
            '<div class="ec__confirm-btns"><button type="button" class="button button--secondary ec__confirm-no">Keep my cart</button><button type="button" class="button ec__confirm-yes" disabled>Yes, empty my cart</button></div>' +
          '</div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(drawer);

    drawer.addEventListener('click', onClick);
    drawer.addEventListener('input', function (e) {
      if (e.target.matches('.ec__q')) filter();
      if (e.target.matches('.ec__confirm-ok')) drawer.querySelector('.ec__confirm-yes').disabled = !e.target.checked;
      if (e.target.matches('.ec__note')) queueNote();
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('.ec__qty input')) setQty(e.target.closest('.ec__item'), parseInt(e.target.value, 10) || 0);
    });
    drawer.addEventListener('focusout', function (e) {
      if (e.target.matches('.ec__note')) { clearTimeout(noteTimer); saveNote(); }
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (!drawer.querySelector('.ec__confirm').hidden) closeConfirm(); else close(); }
      if (e.key === 'Enter' && e.target.matches('.ec__qty input')) { e.preventDefault(); e.target.blur(); }
      if (e.key === 'Enter' && e.target.matches('.ec__promo-input')) { e.preventDefault(); applyCode(); }
      if (e.key === 'Tab') trap(e);
    });
    return drawer;
  }

  function trap(e) {
    var panel = drawer.querySelector('.ec__panel');
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, summary'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- render ---------- */
  function render() {
    var list = drawer.querySelector('.ec__list');
    var items = cart.items || [];
    var lines = items.length;
    drawer.querySelector('.ec__sub').textContent = lines ? (lines + ' item' + (lines === 1 ? '' : 's') + ' \u00b7 ' + cart.item_count + ' unit' + (cart.item_count === 1 ? '' : 's')) : '';
    var capEl = drawer.querySelector('.ec__cap');
    capEl.textContent = lines + ' of ' + cap() + ' items per order';
    capEl.classList.toggle('ec__cap--warn', lines >= cap() * 0.9);
    drawer.querySelector('.ec__clear').hidden = !lines;
    drawer.querySelector('.ec__tools .ec__search').hidden = lines < 2;
    drawer.querySelector('.ec__empty').hidden = !!lines;
    drawer.querySelector('.ec__foot').hidden = !lines;

    /* Totals: original price, discounts (codes + automatic), subtotal */
    var orig = Number(cart.original_total_price || cart.total_price);
    var total = Number(cart.total_price);
    var disc = Math.max(0, orig - total);
    drawer.querySelector('.ec__orig').hidden = disc <= 0;
    drawer.querySelector('.ec__disc').hidden = disc <= 0;
    drawer.querySelector('.ec__orig-val').textContent = money(orig);
    drawer.querySelector('.ec__disc-val').textContent = '\u2212' + money(disc);
    drawer.querySelector('.ec__total').textContent = money(total);

    renderCodes();
    var note = drawer.querySelector('.ec__note');
    if (document.activeElement !== note) note.value = cart.note || '';
    var noteBox = drawer.querySelector('.ec__box--note');
    noteBox.querySelector('.ec__box-state').textContent = (cart.note || '').trim() ? 'Added' : '';
    if ((cart.note || '').trim() && !noteBox.hasAttribute('data-touched')) noteBox.open = true;

    var ship = drawer.querySelector('.ec__ship');
    if (CFG.freeShipping > 0 && lines) {
      ship.hidden = false;
      var left = CFG.freeShipping - total;
      drawer.querySelector('.ec__ship-text').innerHTML = left > 0 ? 'You\'re <strong>' + money(left) + '</strong> away from free shipping' : '<strong>You\'ve unlocked free shipping</strong>';
      drawer.querySelector('.ec__ship-bar span').style.width = Math.min(100, Math.round(total / CFG.freeShipping * 100)) + '%';
      ship.classList.toggle('ec__ship--done', left <= 0);
    } else { ship.hidden = true; }

    list.innerHTML = items.map(function (it, i) {
      var variant = it.variant_title && !it.product_has_only_default_variant ? it.variant_title : '';
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var search = (it.product_title + ' ' + variant + ' ' + (it.sku || '')).toLowerCase();
      var lineDisc = Number(it.original_line_price) > Number(it.final_line_price);
      return '<li class="ec__item" data-key="' + esc(it.key) + '" data-line="' + (i + 1) + '" data-id="' + it.variant_id + '" data-qty="' + it.quantity + '" data-search="' + esc(search) + '">' +
        '<a class="ec__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
        '<div class="ec__info">' +
          '<a class="ec__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (variant ? '<span class="ec__variant">' + esc(variant) + '</span>' : '') +
          (it.sku ? '<span class="ec__sku">SKU ' + esc(it.sku) + '</span>' : '') +
          '<div class="ec__row">' +
            '<div class="ec__prices"><span class="ec__each">' + money(it.final_price) + ' each</span><strong class="ec__line">' + money(it.final_line_price) + (lineDisc ? ' <s>' + money(it.original_line_price) + '</s>' : '') + '</strong></div>' +
            '<div class="ec__qty"><button type="button" class="ec__minus" aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button>' +
            '<input type="number" inputmode="numeric" min="0" value="' + it.quantity + '" aria-label="Quantity of ' + esc(it.product_title) + '">' +
            '<button type="button" class="ec__plus" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>' +
          '</div>' +
          '<p class="ec__err" hidden></p>' +
        '</div>' +
        '<button type="button" class="ec__remove" aria-label="Remove ' + esc(it.product_title) + '">&times;</button>' +
      '</li>';
    }).join('');
    filter();
  }

  function renderCodes() {
    var wrap = drawer.querySelector('.ec__codes');
    var codes = (cart.discount_codes || []);
    wrap.innerHTML = codes.map(function (d) {
      return '<span class="ec__code' + (d.applicable ? '' : ' ec__code--na') + '">' + esc(d.code) + (d.applicable ? '' : ' (not applied)') +
        '<button type="button" class="ec__code-x" data-code="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">&times;</button></span>';
    }).join('');
    var box = drawer.querySelector('.ec__box--promo');
    var applied = codes.filter(function (d) { return d.applicable; });
    box.querySelector('.ec__box-state').textContent = applied.length ? applied.map(function (d) { return d.code; }).join(', ') : '';
    if (codes.length && !box.hasAttribute('data-touched')) box.open = true;
  }

  function filter() {
    var q = (drawer.querySelector('.ec__q').value || '').trim().toLowerCase();
    var shown = 0;
    drawer.querySelectorAll('.ec__item').forEach(function (li) {
      var ok = !q || li.getAttribute('data-search').indexOf(q) !== -1;
      li.hidden = !ok;
      if (ok) shown++;
    });
    drawer.querySelector('.ec__nomatch').hidden = !(q && shown === 0 && cart.items.length);
  }

  function load() {
    return api('/cart.js').then(function (c) { cart = c; render(); return c; });
  }

  /* ---------- promo codes ---------- */
  function promoMsg(text, ok) {
    var m = drawer.querySelector('.ec__promo-msg');
    m.textContent = text;
    m.className = 'ec__promo-msg' + (ok === true ? ' ec__ok' : ok === false ? ' ec__bad' : '');
  }
  function applyCode() {
    var input = drawer.querySelector('.ec__promo-input');
    var code = (input.value || '').trim();
    if (!code) return;
    var btn = drawer.querySelector('.ec__promo-apply');
    btn.disabled = true; btn.textContent = 'Applying...';
    promoMsg('');
    var existing = codesOf(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    api('/cart/update.js', { discount: existing.concat([code]).join(',') }).then(function (c) {
      var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) {
        cart = c; render(); syncTheme(c);
        input.value = '';
        promoMsg('Code ' + hit.code + ' applied.', true);
      } else {
        /* Not valid or doesn't apply to these items: take it back off so it doesn't confuse checkout */
        return api('/cart/update.js', { discount: existing.join(',') }).then(function (c2) {
          cart = c2; render();
          promoMsg('"' + code + '" isn\'t valid or doesn\'t apply to the items in your cart.', false);
        });
      }
    }).catch(function () {
      promoMsg('Could not apply that code. Please try again.', false);
    }).then(function () { btn.disabled = false; btn.textContent = 'Apply'; });
  }
  function removeCode(code) {
    var rest = codesOf(cart).filter(function (c) { return c !== code; });
    api('/cart/update.js', { discount: rest.join(',') }).then(function (c) {
      cart = c; render(); syncTheme(c);
      promoMsg('Code ' + code + ' removed.');
    });
  }

  /* ---------- order note (becomes the order's note: "Notes Customer Added" on packing slips) ---------- */
  function queueNote() {
    var s = drawer.querySelector('.ec__note-status');
    s.textContent = 'Saving...';
    clearTimeout(noteTimer);
    noteTimer = setTimeout(saveNote, 700);
  }
  function saveNote() {
    var note = drawer.querySelector('.ec__note').value;
    if (cart && (cart.note || '') === note) { drawer.querySelector('.ec__note-status').textContent = note.trim() ? 'Saved \u2713' : ''; return; }
    api('/cart/update.js', { note: note }).then(function (c) {
      cart.note = c.note;
      drawer.querySelector('.ec__note-status').textContent = note.trim() ? 'Saved \u2713' : '';
      drawer.querySelector('.ec__box--note .ec__box-state').textContent = note.trim() ? 'Added' : '';
    }).catch(function () {
      drawer.querySelector('.ec__note-status').textContent = 'Not saved, try again';
    });
  }

  /* ---------- line actions ---------- */
  function setQty(li, qty) {
    if (!li) return;
    if (qty < 0) qty = 0;
    var key = li.getAttribute('data-key');
    var prev = Number(li.getAttribute('data-qty'));
    li.querySelector('.ec__qty input').value = qty;
    li.classList.add('ec__item--busy');
    clearTimeout(pending[key]);
    pending[key] = setTimeout(function () {
      if (qty === 0) { undoItem = { id: Number(li.getAttribute('data-id')), quantity: prev, name: li.querySelector('.ec__name').textContent }; }
      api('/cart/change.js', { id: key, quantity: qty }).then(function (c) {
        cart = c;
        var q = drawer.querySelector('.ec__q').value;
        render();
        drawer.querySelector('.ec__q').value = q; filter();
        syncTheme(c);
        if (qty === 0) toast('Removed ' + undoItem.name + '.', true);
        else {
          var now = c.items.filter(function (i) { return i.key === key; })[0];
          if (now && now.quantity < qty) {
            var el = drawer.querySelector('.ec__item[data-key="' + key.replace(/"/g, '') + '"] .ec__err');
            if (el) { el.textContent = 'Only ' + now.quantity + ' available.'; el.hidden = false; }
          }
        }
      }).catch(function (err) {
        li.classList.remove('ec__item--busy');
        li.querySelector('.ec__qty input').value = prev;
        var el = li.querySelector('.ec__err');
        el.textContent = (err && (err.description || err.message)) || 'Could not update quantity.';
        el.hidden = false;
      });
    }, 350);
  }

  function toast(text, withUndo) {
    var t = drawer.querySelector('.ec__toast');
    t.innerHTML = esc(text) + (withUndo ? ' <button type="button" class="ec__undo">Undo</button>' : '');
    t.hidden = false;
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { t.hidden = true; undoItem = null; }, 6000);
  }

  function openConfirm() {
    var c = drawer.querySelector('.ec__confirm');
    drawer.querySelector('.ec__confirm-text').textContent = 'This will remove all ' + cart.items.length + ' item' + (cart.items.length === 1 ? '' : 's') + ' (' + cart.item_count + ' units, ' + money(cart.total_price) + ') from your cart.';
    var ok = drawer.querySelector('.ec__confirm-ok');
    ok.checked = false;
    drawer.querySelector('.ec__confirm-yes').disabled = true;
    c.hidden = false;
    drawer.querySelector('.ec__confirm-no').focus();
  }
  function closeConfirm() {
    drawer.querySelector('.ec__confirm').hidden = true;
    drawer.querySelector('.ec__clear').focus();
  }
  function clearCart() {
    var yes = drawer.querySelector('.ec__confirm-yes');
    yes.disabled = true; yes.textContent = 'Emptying...';
    api('/cart/clear.js', {}).then(function (c) {
      cart = c; render(); syncTheme(c);
      drawer.querySelector('.ec__confirm').hidden = true;
      toast('Your cart is now empty.', false);
    }).catch(function () {
      drawer.querySelector('.ec__confirm-text').textContent = 'Something went wrong. Please try again.';
    }).then(function () { yes.textContent = 'Yes, empty my cart'; });
  }

  function onClick(e) {
    if (e.target.closest('[data-ec-close]')) { close(); return; }
    var sum = e.target.closest('.ec__box > summary');
    if (sum) { sum.parentNode.setAttribute('data-touched', '1'); return; }
    var li = e.target.closest('.ec__item');
    if (e.target.closest('.ec__minus')) { setQty(li, (parseInt(li.querySelector('.ec__qty input').value, 10) || 0) - 1); return; }
    if (e.target.closest('.ec__plus')) { setQty(li, (parseInt(li.querySelector('.ec__qty input').value, 10) || 0) + 1); return; }
    if (e.target.closest('.ec__remove')) { setQty(li, 0); return; }
    if (e.target.closest('.ec__promo-apply')) { applyCode(); return; }
    var cx = e.target.closest('.ec__code-x');
    if (cx) { removeCode(cx.getAttribute('data-code')); return; }
    if (e.target.closest('.ec__clear')) { openConfirm(); return; }
    if (e.target.closest('.ec__confirm-no')) { closeConfirm(); return; }
    if (e.target.closest('.ec__confirm-yes')) { if (drawer.querySelector('.ec__confirm-ok').checked) clearCart(); return; }
    if (e.target === drawer.querySelector('.ec__confirm')) { closeConfirm(); return; }
    if (e.target.closest('.ec__undo') && undoItem) {
      var item = undoItem; undoItem = null;
      drawer.querySelector('.ec__toast').hidden = true;
      api('/cart/add.js', { items: [{ id: item.id, quantity: item.quantity }] }).then(load).then(syncTheme);
    }
    /* Make sure the latest note is saved before leaving for checkout */
    var go = e.target.closest('.ec__checkout, .ec__view');
    if (go && drawer.querySelector('.ec__note').value !== (cart.note || '')) {
      e.preventDefault();
      var href = go.getAttribute('href');
      api('/cart/update.js', { note: drawer.querySelector('.ec__note').value }).then(function () { window.location.href = href; }, function () { window.location.href = href; });
    }
  }

  /* ---------- open / close ---------- */
  function open() {
    build();
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ec-lock');
    var toggle = document.querySelector('.header__cart-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (!cart) drawer.querySelector('.ec__list').innerHTML = '<li class="ec__loading">Loading your cart...</li>';
    setTimeout(function () { drawer.querySelector('.ec__panel').focus(); }, 30);
    return load();
  }
  function close() {
    if (!drawer) return;
    if (cart && drawer.querySelector('.ec__note').value !== (cart.note || '')) saveNote();
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ec-lock');
    var toggle = document.querySelector('.header__cart-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  /* Header cart icon opens the drawer instead of the theme's small dropdown (capture phase runs before the theme) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.header__cart-toggle');
    if (!t || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* Open after the theme's own Add to cart */
  document.documentElement.addEventListener('product:added', function () { open(); });

  window.EntroCart = { open: open, close: close, refresh: load };
})();
